<template>
  <VRow>
    <VCol class="text-center">
      <h2 class="mt-6" :data-testid="error.statusCode">
        {{ title }}
      </h2>
      <div class="font20 text-center">
        <span class="d-block">{{ p }}</span>
        <SBtn
          action
          color="primary"
          class="mt-10"
          nuxt
          data-testid="go-home"
          to="/"
        >
          {{ $t('error.btn.goHome') }}
        </SBtn>
      </div>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>

interface Props {
 error: { statusCode: number}
}

const props = withDefaults(defineProps<Props>(), {
})

const i18n = useI18n()
const title = computed(() => props.error.statusCode === 404
  ? i18n.ts(`page.error.title.${props.error.statusCode}`)
  : i18n.ts(`error.title.${props.error.statusCode}`))

const p = computed(() => i18n.ts(`error.p.${props.error.statusCode}.errorLine`))

useSeoMeta({
  title: i18n.ts(`error.title.${props.error.statusCode}`)
})
</script>

<style lang="scss" scoped>
</style>
